import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import validator from 'validator/es';
import apiClient from './apiClient';

const withDownloadApp = () => {
  const Context = React.createContext({});

  const DownloadAppProvider = ({ children }) => {
    const [popupApp, setPopupApp] = useState(false);

    const [phoneNumber, setPhoneNumber] = useState('');

    const [phoneNumberSuccess, setPhoneNumberSuccess] = useState('');

    const [phoneNumberError, setPhoneNumberError] = useState('');

    const [isSubmitting, setIsSubmitting] = useState(false);

    const popupAppClick = useCallback((e) => {
      if (e.type === 'click') setPopupApp((state) => !state);
    }, []);

    useEffect(() => {
      document.body.classList.toggle('modal-open', popupApp);
    }, [popupApp]);

    const onChangePhoneNumber = useCallback(({ target: { value } }) => {
      setPhoneNumber(value);
    }, []);

    const onSubmit = useCallback(
      (e) => {
        e.preventDefault();

        const input = phoneNumber.replace(/ /gi, '');

        if (validator.isMobilePhone(input, 'en-IN')) {
          (async () => {
            setIsSubmitting(true);

            try {
              await apiClient.post('/send-sms', {
                phoneNumber,
              });

              setPhoneNumber('');

              setPhoneNumberSuccess('SMS sent to your number.');
            } catch (error) {
              /* do nothing */
              setPhoneNumberError('Something went wrong, try again.');
            } finally {
              setIsSubmitting(false);
            }
          })();
        } else {
          setPhoneNumberError('This phone number is invalid.');
        }
      },
      [phoneNumber],
    );

    const clickHandler = useCallback(
      (e) => {
        if (
          popupApp === true &&
          e.target.classList.contains('download-app-popup')
        )
          setPopupApp(false);
      },
      [popupApp],
    );

    const keyDownHandler = useCallback(
      (e) => {
        if (popupApp === true && e.key === 'Escape') setPopupApp(false);
      },
      [popupApp],
    );

    useEffect(() => {
      if (phoneNumberSuccess) {
        const timeout = setTimeout(() => {
          setPhoneNumberSuccess('');
          setPopupApp(false);
        }, 5000);

        return () => {
          clearTimeout(timeout);
        };
      }

      return () => {
        /* do nothing */
      };
    }, [phoneNumberSuccess]);

    useEffect(() => {
      if (phoneNumberError) {
        const timeout = setTimeout(() => {
          setPhoneNumberError('');
        }, 5000);

        return () => {
          clearTimeout(timeout);
        };
      }

      return () => {
        /* do nothing */
      };
    }, [phoneNumberError]);

    useEffect(() => {
      window.addEventListener('click', clickHandler);
      window.addEventListener('keydown', keyDownHandler);

      return () => {
        window.removeEventListener('click', clickHandler);
        window.removeEventListener('keydown', keyDownHandler);
      };
    }, [clickHandler, keyDownHandler]);

    return (
      <Context.Provider
        value={{
          popupApp,
          popupAppClick,
          phoneNumber,
          onChangePhoneNumber,
          isSubmitting,
          phoneNumberSuccess,
          phoneNumberError,
          popupAppSubmit: onSubmit,
        }}>
        {children}
      </Context.Provider>
    );
  };

  DownloadAppProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };

  const useDownloadApp = () => React.useContext(Context);

  return {
    DownloadAppProvider,
    useDownloadApp,
  };
};

export const { DownloadAppProvider, useDownloadApp } = withDownloadApp();
